<form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
    <div class="row m-0">
        <div class="col-md-3">
            <label>Financial Year</label>
            <ng-select name="ESS_TaxFinancialYearID" [items]="FinancialYears" bindLabel="FinancialYear"
                bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Filter.ESS_TaxFinancialYearID"
                placeholder="Financial Year" (change)="clear()" required>
            </ng-select>
            <div class="invalid-feedback">
                Please select financial year!
            </div>
        </div>
        <div class="col-md-auto align-content-end">
            <button class="btn btn-primary" [disabled]="isDisabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Preview':'Loading...'}}</button>
        </div>
    </div>
</form>

<div *ngIf="isDataLoad" class="mt-3">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1">
            <button ngbNavLink>IT Declaration</button>
            <ng-template ngbNavContent>
                <ngb-alert [dismissible]="false" type="light" class="alter-text"
                    *ngIf="this.Filter.DeclarationMainID == 0">
                    <strong><i class="bi bi-info-circle-fill"></i></strong> {{this.DeclarationMessgae}}
                </ngb-alert>
                <div *ngIf="this.Filter.DeclarationMainID > 0">
                    <div class="p-2" style="background: whitesmoke;">
                        <div class="row">
                            <div class="col-md-4">
                                <h5>Overall Tax Summary</h5>
                            </div>
                            <!-- <div class="col-md-4" style="display: ruby;">
                                <i class="bi bi-funnel-fill" style="color:var(--primary)"></i> <span>Financial Year :
                                    <h6>
                                        {{this.Filter.FinancialYearFrom}} -
                                        {{this.Filter.FinancialYearTo}}</h6>
                                </span>
                            </div> -->
                            <div class="col-md-auto">
                                <span style="font-weight: 500;color:darkgray">Tax Regime : </span>
                            </div>
                            <div class="col-md-auto" *ngIf="DTable0.IsNewRegime != null">
                                <h6 class="m-0">{{DTable0.IsNewRegime?'New':'Old'}} Tax Regime
                                    <!-- <span style="color:var(--primary)">(Change)</span> -->
                                </h6>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                                    [routerLink]="['/incometax/compare/rd/' + this.Filter.DeclarationMainID]"><i
                                        class="bi bi-bookmark-check" *ngIf="!isDisabled"></i>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                        *ngIf="isDisabled"></span>
                                    {{!isDisabled?'View Breakup':'Loading...'}}</button>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <span style="font-weight: 500;color:darkgray">Net Taxable Income</span>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{this.Filter.Declaration_NetTaxableIncome}}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <span style="font-weight: 500;color:darkgray">Total Tax</span>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{this.Filter.Declaration_TotalTaxPayable}}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <span style="font-weight: 500;color:darkgray">Tax to be Paid</span>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{this.Filter.Declaration_TaxtobePaid}}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-2">
                            <div class="col-md-12 mb-2">
                                <span style="font-weight: 500;color:darkgray">Status</span>
                            </div>
                            <div class="col-md-12">
                                <span class="badge success">DECLARED</span>
                            </div>
                        </div> -->
                        </div>
                    </div>
                    <div class="p-2 pt-3">
                        <div class="row">
                            <div class="col-6">
                                <span style="font-weight: 500;color:gray">Particulars</span>
                            </div>
                            <div class="col-3 text-end">
                                <span style="font-weight: 500;color:gray">Declared Amount</span>
                            </div>
                            <div class="col-3 text-end">
                                <span style="font-weight: 500;color:gray">Approved Amount</span>
                            </div>
                        </div>
                        <hr />

                        <div *ngFor="let element of DTable1; let i = index">
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="m-0">{{element.sectionName}} (Chapter VI) <span
                                            style="font-weight: 300;font-size: smaller;"
                                            *ngIf="element.sectionLimitAblicable">(Max
                                            Limit :
                                            <i class="bi bi-currency-rupee"></i>{{element.sectionMaxLimit}})</span></h6>
                                </div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="row" *ngFor="let subelement of element.subsections; let i = index">
                                    <div class="col-6 mt-3 ps-4">
                                        <span
                                            style="font-weight: 500;color:gray;font-size: smaller;">{{subelement.SubSectionName}}</span>
                                        <span style="font-weight: 300;font-size: smaller;"
                                            *ngIf="(this.DTable0.IsNewRegime && subelement.IsNewMaxlimitapplicable) || (!this.DTable0.IsNewRegime && subelement.IsOldMaxlimitapplicable)">(Max
                                            Limit :
                                            <i
                                                class="bi bi-currency-rupee"></i>{{this.DTable0.IsNewRegime?subelement.NewRegimeMaxAmount:subelement.OldRegimeMaxAmount}})</span>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.DeclaredAmount}}</h6>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.ApprovedAmount}}</h6>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>

                        <div *ngIf="DTable3.length > 0">
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="m-0">House Rent Paid Details</h6>
                                </div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="col-3 text-end align-self-center"></div>
                            </div>
                        </div>

                        <div *ngFor="let element of DTable3; let i = index">
                            <div class="row">
                                <div class="col-6 mt-3 ps-4">
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">{{element.FromDate}} -
                                        {{element.ToDate}}</span>
                                    <br /><br />
                                    <span
                                        style="font-weight: 500;color:gray;font-size: smaller;">{{element.Address}}</span><br>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">Landload Name :
                                        {{element.NameOfLandlord}}</span><br>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">PAN :
                                        {{element.LandLordPanNo}} -
                                        {{element.IsMetroCity?'Metro':'Non Metro'}}</span>
                                </div>
                                <div class="col-3 text-end align-self-center">
                                    <h6 style="font-weight: 600;"><i
                                            class="bi bi-currency-rupee"></i>{{element.DeclaredAmount}}
                                    </h6>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">(<i
                                            class="bi bi-currency-rupee"></i>{{element.MonthlyDeclaredAmount}} /
                                        Month)</span>
                                </div>
                                <div class="col-3 text-end align-self-center">
                                    <h6 style="font-weight: 600;"><i
                                            class="bi bi-currency-rupee"></i>{{element.ApprovedAmount}}
                                    </h6>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">(<i
                                            class="bi bi-currency-rupee"></i>{{element.MonthlyApprovedAmount}} /
                                        Month)</span>
                                </div>
                            </div>
                            <hr />
                        </div>

                        <div *ngFor="let element of DTable4; let i = index">
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="m-0">{{element.sectionName}} (Other) <span
                                            style="font-weight: 300;font-size: smaller;"
                                            *ngIf="element.sectionLimitAblicable">(Max
                                            Limit :
                                            <i class="bi bi-currency-rupee"></i>{{element.sectionMaxLimit}})</span></h6>
                                </div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="row" *ngFor="let subelement of element.subsections; let i = index">
                                    <div class="col-6 mt-3 ps-4">
                                        <span
                                            style="font-weight: 500;color:gray;font-size: smaller;">{{subelement.SubSectionName}}</span>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.DeclaredAmount}}</h6>
                                        <span style="font-weight: 300;font-size: smaller;"
                                            *ngIf="(this.DTable0.IsNewRegime && subelement.IsNewMaxlimitapplicable) || (!this.DTable0.IsNewRegime && subelement.IsOldMaxlimitapplicable)">(Max
                                            Limit :
                                            <i
                                                class="bi bi-currency-rupee"></i>{{this.DTable0.IsNewRegime?subelement.NewRegimeMaxAmount:subelement.OldRegimeMaxAmount}})</span>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.ApprovedAmount}}</h6>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>

                        <div class="card my-1">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">
                                        <span class="custome-header">
                                            <i class="bi bi-briefcase px-2"></i>Previous Employment Details
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0 py-2 px-3">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>Remark</th>
                                                        <th>Basic</th>
                                                        <th>DA</th>
                                                        <th>HRA</th>
                                                        <th>Allowance</th>
                                                        <th>Gross</th>
                                                        <th>PT</th>
                                                        <th>PF</th>
                                                        <th>TDS</th>
                                                        <th>Deduction</th>
                                                        <th>Net</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of DTable2; let i = index">
                                                        <td class="text-end">{{element.Remarks}}</td>
                                                        <td class="text-end">{{element.Basic}}</td>
                                                        <td class="text-end">{{element.DA}}</td>
                                                        <td class="text-end">{{element.HRA}}</td>
                                                        <td class="text-end">{{element.OtherAllowance}}</td>
                                                        <td class="text-end">{{element.GrossAmount}}</td>
                                                        <td class="text-end">{{element.PT}}</td>
                                                        <td class="text-end">{{element.PF}}</td>
                                                        <td class="text-end">{{element.TDS}}</td>
                                                        <td class="text-end">{{element.OtherDeduction}}</td>
                                                        <td class="text-end">{{element.NetAmount}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card my-1">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">
                                        <span class="custome-header">
                                            <i class="bi bi-cash-stack px-2"></i>Are you receiving rental income from
                                            Let
                                            out
                                            Property?
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="card-body p-0 py-2 px-3">
                                    <div class="row">
                                        <div class="col p-0">
                                            <div class="table-container">
                                                <table class="customeDatatable table table-bordered">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th>Annual Rent Received</th>
                                                            <th>Municipal Taxes</th>
                                                            <th>Net AnnualValue</th>
                                                            <th>Standard Deduction 30%</th>
                                                            <th>Repaying HomeLoan</th>
                                                            <th>Principal Paid OnHomeLoan</th>
                                                            <th>Interest Paid OnHomeLoan</th>
                                                            <th>Name Of TheLender</th>
                                                            <th>Lender PanNo</th>
                                                            <th>NetIncome/Loss</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let element of DTable5; let i = index">
                                                            <td class="text-end">{{element.AnnualRentReceived}}</td>
                                                            <td class="text-end">{{element.MunicipalTaxesPaid}}</td>
                                                            <td class="text-end">{{element.NetAnnualValue}}</td>
                                                            <td class="text-end">{{element.StandardDeduction}}</td>
                                                            <td>{{element.RepayingHomeLoanForThisProperty?'Yes':'No'}}
                                                            </td>
                                                            <td class="text-end">{{element.PrincipalPaidOnHomeLoan}}
                                                            </td>
                                                            <td class="text-end">{{element.InterestPaidOnHomeLoan}}</td>
                                                            <td>{{element.NameOfTheLender}}</td>
                                                            <td>{{element.LenderPanNo}}</td>
                                                            <td class="text-end">
                                                                {{element.NetIncomeLossFromHouseProperty}}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <hr />
                Static Data
                <hr />
                <div class="row">
                    <div class="col-6">
                        <h6 class="m-0">House Rent Paid Details</h6>
                        <br />
                        <span style="font-weight: 500;color:gray;font-size: smaller;">Apr 2020 - Mar 2021</span>
                        <br /><br />
                        <span style="font-weight: 500;color:gray;font-size: smaller;">147,Alfredo, 8th East Street,
                            Thiruvanimiyur, Chennai-41</span><br>
                        <span style="font-weight: 500;color:gray;font-size: smaller;">Landload Name :
                            Sekar</span><br>
                        <span style="font-weight: 500;color:gray;font-size: smaller;">PAN : AAAAA1234P -
                            Metro</span>
                    </div>
                    <div class="col-3 text-end align-self-center">
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>98,400.00</h6>
                        <span style="font-weight: 500;color:gray;font-size: smaller;">(<i
                                class="bi bi-currency-rupee"></i>8,200.00 / Month)</span>
                    </div>
                    <div class="col-3 text-end align-self-center">
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>98,400.00</h6>
                        <span style="font-weight: 500;color:gray;font-size: smaller;">(<i
                                class="bi bi-currency-rupee"></i>8,200.00 / Month)</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-6">
                        <h6 class="m-0">80C Investments <span style="font-weight: 300;font-size: smaller;">(Max
                                Limit :
                                <i class="bi bi-currency-rupee"></i>1,50,000.00)</span></h6>
                        <br />
                        <span style="font-weight: 500;color:gray;font-size: smaller;">Employee Provident Fund
                            (Pre-Tax
                            Deduction)</span>
                        <br /><br />
                        <span style="font-weight: 500;color:gray;font-size: smaller;">Life Insurance Premium</span>
                    </div>
                    <div class="col-3 text-end align-self-center">
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>1,800.00</h6>
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>1,00,000.00</h6>
                    </div>
                    <div class="col-3 text-end align-self-center">
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>1,800.00</h6>
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>1,00,000.00</h6>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-6">
                        <h6 class="m-0">80D Investments <span style="font-weight: 300;font-size: smaller;">(Max
                                Limit :
                                <i class="bi bi-currency-rupee"></i>1,00,000.00)</span></h6>
                        <br />
                        <span style="font-weight: 500;color:gray;font-size: smaller;">Mediclaim Policy for self,
                            spouse,
                            children - 80D</span>
                        <br /><br />
                        <span style="font-weight: 500;color:gray;font-size: smaller;">Preventive health check up -
                            80D</span>
                    </div>
                    <div class="col-3 text-end align-self-center">
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>22,000.00</h6>
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>4,000.00</h6>
                    </div>
                    <div class="col-3 text-end align-self-center">
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>22,000.00</h6>
                        <br />
                        <h6 style="font-weight: 600;"><i class="bi bi-currency-rupee"></i>4,000.00</h6>
                    </div>
                </div> -->
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <button ngbNavLink>Proof Of Investments</button>
            <ng-template ngbNavContent>
                <ngb-alert [dismissible]="false" type="light" class="alter-text"
                    *ngIf="this.Filter.InvestmentMainID == 0">
                    <strong><i class="bi bi-info-circle-fill"></i></strong> {{this.InvestmentsMessgae}}
                </ngb-alert>

                <div *ngIf="this.Filter.InvestmentMainID > 0">
                    <div class="p-2" style="background: whitesmoke;">
                        <div class="row">
                            <div class="col-md-4">
                                <h5>Overall Tax Summary</h5>
                            </div>
                            <!-- <div class="col-md-4" style="display: ruby;">
                                <i class="bi bi-funnel-fill" style="color:var(--primary)"></i> <span>Financial Year :
                                    <h6>
                                        {{this.Filter.FinancialYearFrom}} -
                                        {{this.Filter.FinancialYearTo}}</h6>
                                </span>
                            </div> -->
                            <div class="col-md-auto">
                                <span style="font-weight: 500;color:darkgray">Tax Regime : </span>
                            </div>
                            <div class="col-auto">
                                <h6 class="m-0">{{ETable0.IsNewRegime?'New':'Old'}} Tax Regime </h6>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                                    [routerLink]="['/incometax/compare/id/' + this.Filter.InvestmentMainID]"><i
                                        class="bi bi-bookmark-check" *ngIf="!isDisabled"></i>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                        *ngIf="isDisabled"></span>
                                    {{!isDisabled?'View Breakup':'Loading...'}}</button>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <span style="font-weight: 500;color:darkgray">Net Taxable Income</span>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{this.Filter.Investment_NetTaxableIncome}}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <span style="font-weight: 500;color:darkgray">Total Tax</span>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{this.Filter.Investment_TotalTaxPayable}}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <span style="font-weight: 500;color:darkgray">Tax to be Paid</span>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{this.Filter.Investment_TaxtobePaid}}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-2">
                            <div class="col-md-12 mb-2">
                                <span style="font-weight: 500;color:darkgray">Status</span>
                            </div>
                            <div class="col-md-12">
                                <span class="badge success">INVESTMENT</span>
                            </div>
                        </div> -->
                        </div>
                    </div>
                    <div class="p-2 pt-3">
                        <div class="row">
                            <div class="col-6">
                                <span style="font-weight: 500;color:gray">Particulars</span>
                            </div>
                            <div class="col-3 text-end">
                                <span style="font-weight: 500;color:gray">Proof Submission Amount</span>
                            </div>
                            <div class="col-3 text-end">
                                <span style="font-weight: 500;color:gray">Approved Amount</span>
                            </div>
                        </div>
                        <hr />

                        <div *ngFor="let element of ETable1; let i = index">
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="m-0">{{element.sectionName}} (Chapter VI) <span
                                            style="font-weight: 300;font-size: smaller;"
                                            *ngIf="element.sectionLimitAblicable">(Max
                                            Limit :
                                            <i class="bi bi-currency-rupee"></i>{{element.sectionMaxLimit}})</span></h6>
                                </div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="row" *ngFor="let subelement of element.subsections; let j = index">
                                    <div class="col-6 mt-3 ps-4">
                                        <span
                                            style="font-weight: 500;color:gray;font-size: smaller;">{{subelement.SubSectionName}}</span>
                                        <span style="font-weight: 300;font-size: smaller;"
                                            *ngIf="(this.ETable0.IsNewRegime && subelement.IsNewMaxlimitapplicable) || (!this.ETable0.IsNewRegime && subelement.IsOldMaxlimitapplicable)">(Max
                                            Limit :
                                            <i
                                                class="bi bi-currency-rupee"></i>{{this.ETable0.IsNewRegime?subelement.NewRegimeMaxAmount:subelement.OldRegimeMaxAmount}})</span>

                                        <i type="button"
                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5 ms-2"
                                            (click)="subelement.ESS_EmpTaxInvestmentDetails_Attachment.length > 0?attachmentPopup(i,2,j):null">
                                            <span *ngIf="subelement.ESS_EmpTaxInvestmentDetails_Attachment.length > 0"
                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                style="font-size: 10px;">
                                                {{subelement.ESS_EmpTaxInvestmentDetails_Attachment.length}}
                                            </span>
                                        </i>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.ProofSubmissionAmount}}
                                        </h6>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.ApprovedAmount}}</h6>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>

                        <div *ngIf="ETable3.length > 0">
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="m-0">House Rent Paid Details</h6>
                                </div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="col-3 text-end align-self-center"></div>
                            </div>
                        </div>

                        <div *ngFor="let element of ETable3; let i = index">
                            <div class="row">
                                <div class="col-6 mt-3 ps-4">
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">{{element.FromDate}} -
                                        {{element.ToDate}}</span>
                                    <i type="button"
                                        class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5 ms-2"
                                        (click)="element.ESS_EmpTaxInvestmentDetails_HRAAttachment.length > 0?attachmentPopup(i,3):null">
                                        <span *ngIf="element.ESS_EmpTaxInvestmentDetails_HRAAttachment.length > 0"
                                            class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                            style="font-size: 10px;">
                                            {{element.ESS_EmpTaxInvestmentDetails_HRAAttachment.length}}
                                        </span>
                                    </i>
                                    <br /><br />
                                    <span
                                        style="font-weight: 500;color:gray;font-size: smaller;">{{element.Address}}</span><br>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">Landload Name :
                                        {{element.NameOfLandlord}}</span><br>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">PAN :
                                        {{element.LandLordPanNo}} -
                                        {{element.IsMetroCity?'Metro':'Non Metro'}}</span>
                                </div>
                                <div class="col-3 text-end align-self-center">
                                    <h6 style="font-weight: 600;"><i
                                            class="bi bi-currency-rupee"></i>{{element.ProofSubmissionAmount}}
                                    </h6>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">(<i
                                            class="bi bi-currency-rupee"></i>{{element.MonthlyProofSubmissionAmount}} /
                                        Month)</span>
                                </div>
                                <div class="col-3 text-end align-self-center">
                                    <h6 style="font-weight: 600;"><i
                                            class="bi bi-currency-rupee"></i>{{element.ApprovedAmount}}
                                    </h6>
                                    <span style="font-weight: 500;color:gray;font-size: smaller;">(<i
                                            class="bi bi-currency-rupee"></i>{{element.MonthlyApprovedAmount}} /
                                        Month)</span>
                                </div>
                            </div>
                            <hr />
                        </div>

                        <div *ngFor="let element of ETable4; let i = index">
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="m-0">{{element.sectionName}} (Other) <span
                                            style="font-weight: 300;font-size: smaller;"
                                            *ngIf="element.sectionLimitAblicable">(Max
                                            Limit :
                                            <i class="bi bi-currency-rupee"></i>{{element.sectionMaxLimit}})</span></h6>
                                </div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="col-3 text-end align-self-center"></div>
                                <div class="row" *ngFor="let subelement of element.subsections; let i = index">
                                    <div class="col-6 mt-3 ps-4">
                                        <span
                                            style="font-weight: 500;color:gray;font-size: smaller;">{{subelement.SubSectionName}}</span>
                                        <span style="font-weight: 300;font-size: smaller;"
                                            *ngIf="(this.ETable0.IsNewRegime && subelement.IsNewMaxlimitapplicable) || (!this.ETable0.IsNewRegime && subelement.IsOldMaxlimitapplicable)">(Max
                                            Limit :
                                            <i
                                                class="bi bi-currency-rupee"></i>{{this.ETable0.IsNewRegime?subelement.NewRegimeMaxAmount:subelement.OldRegimeMaxAmount}})</span>
                                        <i type="button"
                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5 ms-2"
                                            (click)="subelement.ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0?attachmentPopup(i,5):null">
                                            <span
                                                *ngIf="subelement.ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0"
                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                style="font-size: 10px;">
                                                {{subelement.ESS_EmpTaxInvestmentDetails_OthersAttachment.length}}
                                            </span>
                                        </i>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.ProofSubmissionAmount}}
                                        </h6>
                                    </div>
                                    <div class="col-3 text-end align-self-center">
                                        <h6 style="font-weight: 600;"><i
                                                class="bi bi-currency-rupee"></i>{{subelement.ApprovedAmount}}</h6>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>

                        <div class="card my-1">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">
                                        <span class="custome-header">
                                            <i class="bi bi-briefcase px-2"></i>Previous Employment Details
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0 px-3 py-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>Remark</th>
                                                        <th>Basic</th>
                                                        <th class="text-end">DA</th>
                                                        <th class="text-end">HRA</th>
                                                        <th class="text-end">Allowance</th>
                                                        <th class="text-end">Gross</th>
                                                        <th class="text-end">PT</th>
                                                        <th class="text-end">PF</th>
                                                        <th class="text-end">TDS</th>
                                                        <th class="text-end">Deduction</th>
                                                        <th class="text-end">Net</th>
                                                        <th class="sticky-col">Attachment</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of ETable2; let i = index">
                                                        <td>
                                                            {{element.Remarks}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.Basic}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.DA}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.HRA}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.OtherAllowance}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.GrossAmount}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.PT}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.PF}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.TDS}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.OtherDeduction}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.NetAmount}}
                                                        </td>
                                                        <td class="sticky-col"
                                                            style="align-content: center;text-align: -webkit-center;">
                                                            <i type="button"
                                                                class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                                (click)="element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.length > 0?attachmentPopup(i,1):null">
                                                                <span
                                                                    *ngIf="element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.length > 0"
                                                                    class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                    style="font-size: 10px;">
                                                                    {{element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.length}}
                                                                </span>
                                                            </i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card my-1">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">
                                        <span class="custome-header">
                                            <i class="bi bi-cash-stack px-2"></i>Are you receiving rental income from
                                            Let
                                            out
                                            Property?
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0 px-3 py-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th class="text-end">Annual Rent Received</th>
                                                        <th class="text-end">Municipal Taxes</th>
                                                        <th class="text-end">Net AnnualValue</th>
                                                        <th class="text-end">Standard Deduction 30%</th>
                                                        <th>Repaying HomeLoan</th>
                                                        <th class="text-end">Principal Paid OnHomeLoan</th>
                                                        <th class="text-end">Interest Paid OnHomeLoan</th>
                                                        <th>Name Of TheLender</th>
                                                        <th>Lender PanNo</th>
                                                        <th class="text-end">NetIncome/Loss</th>
                                                        <th>Attachment</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of ETable5; let i = index">
                                                        <td class="text-end">
                                                            {{element.AnnualRentReceived}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.MunicipalTaxesPaid}}
                                                        </td>
                                                        <td class="text-end">
                                                            <span
                                                                class="custom-control">{{element.NetAnnualValue}}</span>
                                                        </td>
                                                        <td class="text-end">
                                                            <span
                                                                class="custom-control">{{element.StandardDeduction}}</span>
                                                        </td>
                                                        <td style="align-content: center;text-align: -webkit-center;">
                                                            {{element.RepayingHomeLoanForThisProperty?'Yes':"No"}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.PrincipalPaidOnHomeLoan}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.InterestPaidOnHomeLoan}}
                                                        </td>
                                                        <td>
                                                            {{element.NameOfTheLender}}
                                                        </td>
                                                        <td>
                                                            {{element.LenderPanNo}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.NetIncomeLossFromHouseProperty}}
                                                        </td>
                                                        <td style="align-content: center;text-align: -webkit-center;">
                                                            <i type="button"
                                                                class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                                (click)="element.ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0?attachmentPopup(i, 4):null">
                                                                <span
                                                                    *ngIf="element.ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0"
                                                                    class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                    style="font-size: 10px;">
                                                                    {{element.ESS_EmpTaxInvestmentDetails_LOPAttachment.length}}
                                                                </span>
                                                            </i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>